var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "#fff",
    viewBox: "0 0 25.114 20.928",
    className: "pageIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462",
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M27.324,4.79H17.557L15.59,2.823A2.8,2.8,0,0,0,13.609,2H7.79A2.787,2.787,0,0,0,5.014,4.79L5,20.138a2.8,2.8,0,0,0,2.79,2.79H27.324a2.8,2.8,0,0,0,2.79-2.79V7.581A2.8,2.8,0,0,0,27.324,4.79ZM23.138,17.348H11.976a.7.7,0,0,1-.558-1.116l1.925-2.553a.692.692,0,0,1,1.116,0l1.7,2.274,3.1-4.144a.692.692,0,0,1,1.116,0L23.7,16.231A.7.7,0,0,1,23.138,17.348Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentation);
export default __webpack_public_path__ + "static/media/icon_documentation.7bb6f262db8b10d8021cbc1706769fc2.svg";
export { ForwardRef as ReactComponent };